var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.show,"opacity":"0.4","blur":"2px","variant":"dark","no-wrap":""},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',{staticClass:"panel-loading"},[_c('img',{attrs:{"src":"images/ico-loading.gif"}}),_c('div',[_vm._v(_vm._s(_vm.$t(_vm.message || "Loading...")))])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }